import React from 'react';
import { LocalizedTransportationOption } from '../../API/GoMoto';
import { TransportType } from '../../API/Enums';
import { TransportationButton } from './TransportationButton';
import css from './TransportationButtonList.module.scss';

interface ITransportationButtonListProps<T extends LocalizedTransportationOption = LocalizedTransportationOption> {
    transportationOptions: T[];
    onClick: (tranportOpt: T) => void;
}

const sortOrder = [TransportType.drop, TransportType.shuttle, TransportType.wait, TransportType.loaner, TransportType.notNeeded];

export const TransportationButtonList = React.memo((props: ITransportationButtonListProps) => {
    return (
        <div className={css.transportationButtonList}>
            {props.transportationOptions
                .sort((a, b) => sortOrder.indexOf(a.type) - sortOrder.indexOf(b.type))
                .map((map, index) => (
                    <TransportationButton
                        key={map.type + '|' + map.subtype}
                        transportOp={map}
                        onClick={props.onClick}
                    />
                ))}
        </div>
    );
});
